import axiosInstance from './axiosInstance';

export const startExam = async (examId, userId) => {
  try {
    const response = await axiosInstance.post(`/api/start-exam/${examId}?userId=${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error starting exam:', error);
    throw error;
  }
};

export const getNextQuestion = async (userExamData) => {
  try {
    const response = await axiosInstance.post('/user-exams/nextquestion', userExamData);
    return response.data;
  } catch (error) {
    console.error('Error fetching next question:', error);
    throw error;
  }
};